import { render, staticRenderFns } from "@/agilis/components/DataTableV2/DataTableV2ItemView/DataTableV2ItemView.html?vue&type=template&id=01c5d521&scoped=true&external"
import script from "./PriceItemTableView.js?vue&type=script&lang=js&external"
export * from "./PriceItemTableView.js?vue&type=script&lang=js&external"
import style0 from "@/agilis/components/DataTableV2/DataTableV2ItemView/DataTableV2ItemView.css?vue&type=style&index=0&id=01c5d521&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5d521",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VToolbar})
